import { render, staticRenderFns } from "./CustomSelectionOverviewView.vue?vue&type=template&id=796b7a61&scoped=true&"
import script from "./CustomSelectionOverviewView.vue?vue&type=script&lang=js&"
export * from "./CustomSelectionOverviewView.vue?vue&type=script&lang=js&"
import style0 from "./CustomSelectionOverviewView.vue?vue&type=style&index=0&id=796b7a61&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796b7a61",
  null
  
)

export default component.exports